import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prepareFormData, useFormHandler } from '../../components/Custom_Hooks/useFormHandler';
import { companyUserCreate, companyUserUpdate, contraLedgerListing, groupList, companyUserList } from '../../redux/actions/action-creator';
import Form from '../../components/Form/Form';
import MasterCreationFooter from '../../components/Footer/Master_Footer/MasterCreationFooter';
import { toast } from 'react-toastify';

const defaultPermissionsList = [
    // MASTERS
    { id: 1, category: 'MASTERS', name: 'Groups', type: 'Accounting Masters', create: true, alter: true, view: true, delete: true, print: false, export: false, email: false, whatsapp: false },
    { id: 2, category: 'MASTERS', name: 'Ledgers', type: 'Accounting Masters', create: true, alter: true, view: true, delete: false, print: true, export: false, email: false, whatsapp: false },
    { id: 3, category: 'MASTERS', name: 'Voucher Types', type: 'Accounting Masters', create: true, alter: false, view: true, delete: false, print: true, export: true, email: false, whatsapp: false },
    { id: 4, category: 'MASTERS', name: 'Stock Groups', type: 'Inventory Masters', create: false, alter: false, view: true, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 5, category: 'MASTERS', name: 'Stock Items', type: 'Inventory Masters', create: true, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: true },
    { id: 6, category: 'MASTERS', name: 'Stock Categories', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 7, category: 'MASTERS', name: 'Stock Company', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 8, category: 'MASTERS', name: 'Units', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 9, category: 'MASTERS', name: 'Godowns', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    // VOUCHER TYPES
    { id: 10, category: 'VOUCHER TYPES', name: 'Contra', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: false, export: false, email: false, whatsapp: false },
    { id: 11, category: 'VOUCHER TYPES', name: 'Credit Note', type: 'Transactions', create: true, alter: true, view: true, delete: false, print: true, export: false, email: false, whatsapp: false },
    { id: 12, category: 'VOUCHER TYPES', name: 'Debit Note', type: 'Transactions', create: true, alter: false, view: true, delete: false, print: true, export: true, email: false, whatsapp: false },
    { id: 13, category: 'VOUCHER TYPES', name: 'Delivery Note', type: 'Transactions', create: false, alter: false, view: true, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 14, category: 'VOUCHER TYPES', name: 'Journal', type: 'Transactions', create: true, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: true },
    { id: 15, category: 'VOUCHER TYPES', name: 'Payment', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 16, category: 'VOUCHER TYPES', name: 'Physical Stock', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 17, category: 'VOUCHER TYPES', name: 'Purchase', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 18, category: 'VOUCHER TYPES', name: 'Purchase Order', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 19, category: 'VOUCHER TYPES', name: 'Receipt', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 20, category: 'VOUCHER TYPES', name: 'Receipt Note', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 21, category: 'VOUCHER TYPES', name: 'Sales', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 22, category: 'VOUCHER TYPES', name: 'Sales Order', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 23, category: 'VOUCHER TYPES', name: 'Stock Transfer', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    // REPORTS
    { id: 24, category: 'REPORTS', name: 'DayBook', type: 'Reports', create: false, alter: false, view: true, delete: false, print: false, export: false, email: false, whatsapp: false },
    { id: 25, category: 'REPORTS', name: 'Ledger', type: 'Reports', create: false, alter: false, view: true, delete: false, print: true, export: false, email: false, whatsapp: false },
    { id: 26, category: 'REPORTS', name: 'Stock Summary', type: 'Reports', create: false, alter: false, view: true, delete: false, print: true, export: true, email: false, whatsapp: false },
    { id: 27, category: 'REPORTS', name: 'Balance Sheet', type: 'Reports', create: false, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 28, category: 'REPORTS', name: 'Profit & Loss', type: 'Reports', create: false, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 29, category: 'REPORTS', name: 'Trial Balance', type: 'Reports', create: false, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: false }
];

const mapRawPermissions = (rawList) => {
    if (!Array.isArray(rawList)) return defaultPermissionsList;
    return defaultPermissionsList.map(def => {
        const matched = rawList.find(r => 
            (r.name && r.name.toLowerCase().trim() === def.name.toLowerCase().trim()) || 
            (r.feature_name && r.feature_name.toLowerCase().trim() === def.name.toLowerCase().trim())
        );
        if (matched) {
            return {
                ...def,
                id: matched.id || matched.permission_id || def.id,
                create: String(matched.create ?? matched.can_create ?? '') === '1' || matched.create === true,
                alter: String(matched.alter ?? matched.can_alter ?? '') === '1' || matched.alter === true,
                view: String(matched.view ?? matched.can_view ?? '') === '1' || matched.view === true,
                delete: String(matched.delete ?? matched.can_delete ?? '') === '1' || matched.delete === true,
                print: String(matched.print ?? matched.can_print ?? '') === '1' || matched.print === true,
                export: String(matched.export ?? matched.can_export ?? '') === '1' || matched.export === true,
                email: String(matched.email ?? matched.can_email ?? '') === '1' || matched.email === true,
                whatsapp: String(matched.whatsapp ?? matched.can_whatsapp ?? '') === '1' || matched.whatsapp === true,
            };
        }
        return def;
    });
};

function UserAndPasswordCreate({ closeModal_sec, onSuccess, editData, viewOnly }) {
    const dispatch = useDispatch();
    const { userData = null } = useSelector(state => state.auth);
    const [submitConfirm, setSubmitConfirm] = useState('');
    const [ledgers, setLedgers] = useState([]);

    // Initial state for form fields
    const [formData, setFormData] = useState({
        company_id: userData?.company_id || localStorage.getItem("company_id") || '',
        ledgerName: editData ? editData.account_no : '',
        username: editData ? editData.username : 'snlyadav11',
        password: '',
        confirmPassword: '',
        email: editData ? (editData.email || '') : '',
        designation: editData ? editData.designation : 'Owner',
        userStatus: editData ? editData.status : 'Active',
        allowedBackDated: editData ? (editData.allowedBackDated || 'Yes') : 'Yes',
        cutOffDate: editData ? (editData.cutOffDate || '23-Dec-2025 (Tuesday)') : '23-Dec-2025 (Tuesday)',
    });

    useEffect(() => {
        const fetchLedgers = async () => {
            const companyId = userData?.company_id || localStorage.getItem("company_id");
            if (companyId) {
                const formDataObj = new FormData();
                formDataObj.append('company_id', companyId);
                try {
                    // 1. Fetch groups of the company
                    const groupsResponse = await dispatch(groupList(formDataObj));
                    let groupIds = [];
                    if (groupsResponse?.status && groupsResponse?.data) {
                        const findGroupIdsByName = (groups, targetNames) => {
                            let ids = [];
                            const traverse = (list) => {
                                if (!list) return;
                                for (const group of list) {
                                    if (targetNames.some(name => group.name?.toLowerCase().trim() === name.toLowerCase().trim())) {
                                        ids.push(group.id);
                                    }
                                    if (group.sub_primary_group1) {
                                        traverse(group.sub_primary_group1);
                                    }
                                }
                            };
                            traverse(groups);
                            return ids;
                        };
                        groupIds = findGroupIdsByName(groupsResponse.data, ['Sundry Debtors', 'Sundry Creditors']);
                    }

                    // 2. Fetch ledgers for those group IDs
                    const ledgersFormData = new FormData();
                    ledgersFormData.append('group_ids', groupIds.join(','));
                    ledgersFormData.append('company_id', companyId);

                    const response = await dispatch(contraLedgerListing(ledgersFormData));
                    if (response?.status && response?.data) {
                        const sortedLedgers = [...response.data].sort((a, b) =>
                            (a.ledger_name || '').localeCompare(b.ledger_name || '')
                        );
                        setLedgers(sortedLedgers);
                        if (!editData) {
                            const firstLedger = sortedLedgers[0];
                            setFormData(prev => ({
                                ...prev,
                                ledgerName: firstLedger?.id || '',
                                email: firstLedger?.email || ''
                            }));
                        }
                    }
                } catch (error) {
                    console.error("Error fetching groups/ledgers:", error);
                }
            }
        };
        fetchLedgers();
    }, [dispatch, userData, editData]);

    useEffect(() => {
        const fetchUserDetails = async () => {
            if (editData && editData.id) {
                const companyId = userData?.company_id || localStorage.getItem("company_id");
                const formDataObj = new FormData();
                formDataObj.append('company_id', companyId);
                formDataObj.append('id', editData.id);
                try {
                    const response = await dispatch(companyUserList(formDataObj));
                    if (response?.status && response?.data) {
                        const userDetail = Array.isArray(response.data)
                            ? (response.data.find(u => String(u.id) === String(editData.id)) || response.data[0])
                            : response.data;
                        console.log("userDetail fetched from api/company_users_list:", userDetail);
                        if (userDetail) {
                            setFormData(prev => ({
                                ...prev,
                                ledgerName: userDetail.ledger_id || userDetail.account_no || prev.ledgerName,
                                username: userDetail.username || prev.username,
                                email: userDetail.email || prev.email,
                                designation: userDetail.designation || prev.designation,
                                userStatus: userDetail.user_status || userDetail.status || prev.userStatus,
                                allowedBackDated: userDetail.allowed_back_dated || userDetail.allowedBackDated || prev.allowedBackDated,
                                cutOffDate: userDetail.cut_off_date || userDetail.cutOffDate || prev.cutOffDate,
                            }));
                            const rawPerms = userDetail.permissions || userDetail.user_permissions;
                            if (rawPerms) {
                                try {
                                    const parsedPerms = typeof rawPerms === 'string' ? JSON.parse(rawPerms) : rawPerms;
                                    const mapped = mapRawPermissions(parsedPerms);
                                    setPermissions(mapped);
                                    // Deep clone the mapped permissions to avoid sharing references
                                    setInitialPermissions(JSON.parse(JSON.stringify(mapped)));
                                } catch (e) {
                                    console.error("Failed to parse permissions from details API response:", e);
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error("Failed to fetch user details:", error);
                }
            }
        };
        fetchUserDetails();
    }, [editData, dispatch, userData]);

    const [initialPermissions, setInitialPermissions] = useState(() => {
        if (editData && editData.permissions) {
            try {
                const parsed = typeof editData.permissions === 'string' ? JSON.parse(editData.permissions) : editData.permissions;
                const mapped = mapRawPermissions(parsed);
                // Deep clone to avoid reference sharing
                return JSON.parse(JSON.stringify(mapped));
            } catch (e) {
                console.error("Failed to parse editData permissions:", e);
            }
        }
        return null;
    });

    // Permission Grid rows
    const [permissions, setPermissions] = useState(() => {
        if (editData && editData.permissions) {
            try {
                const parsed = typeof editData.permissions === 'string' ? JSON.parse(editData.permissions) : editData.permissions;
                return mapRawPermissions(parsed);
            } catch (e) {
                console.error("Failed to parse editData permissions:", e);
            }
        }
        return defaultPermissionsList;
    });

    // Active focused cell coordinates for custom navigation [rowIndex, colName]
    const [focusedCell, setFocusedCell] = useState([null, null]);

    // Focus references
    const refs = {
        ledgerName: useRef(null),
        username: useRef(null),
        password: useRef(null),
        confirmPassword: useRef(null),
        email: useRef(null),
        designation: useRef(null),
        userStatus: useRef(null),
        allowedBackDated: useRef(null),
        cutOffDate: useRef(null),
    };

    // Sequential inputs order for Enter key navigation
    const inputOrder = [
        'ledgerName', 'username', 'password', 'confirmPassword', 'email', 'designation', 'userStatus', 'allowedBackDated', 'cutOffDate'
    ];

    const handleFocusReset = () => {
        setSubmitConfirm('');
        refs.ledgerName.current?.focus();
    };

    const submitConfirmRef = useRef(submitConfirm);
    useEffect(() => {
        submitConfirmRef.current = submitConfirm;
    }, [submitConfirm]);

    useEffect(() => {
        // Block global Escape navigation while this modal is open
        document.body.setAttribute('data-modal-open', 'true');
        // Auto focus the first field on mount
        setTimeout(() => {
            refs.ledgerName.current?.focus();
        }, 100);
        return () => {
            document.body.removeAttribute('data-modal-open');
        };
    }, []);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Escape') {
                if (viewOnly) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    closeModal_sec && closeModal_sec();
                    return;
                }

                if (submitConfirmRef.current) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    handleFocusReset();
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();
                submitConfirmRef.current = 'Quit';
                setSubmitConfirm('Quit');
                document.activeElement?.blur();
            }
        };
        window.addEventListener('keydown', handleKeyPress, true);
        return () => {
            window.removeEventListener('keydown', handleKeyPress, true);
        };
    }, [viewOnly, closeModal_sec]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'ledgerName') {
                const selectedLedger = ledgers.find(l => String(l.id) === String(value));
                if (selectedLedger) {
                    updated.email = selectedLedger.email || '';
                }
            }
            return updated;
        });
    };

    const permissionCols = ['create', 'alter', 'view', 'delete', 'print', 'export', 'email', 'whatsapp'];

    useEffect(() => {
        if (focusedCell[0] !== null && focusedCell[1] !== null) {
            const element = document.querySelector(`input[data-row="${focusedCell[0]}"][data-col="${focusedCell[1]}"]`);
            element?.focus();
        }
    }, [focusedCell]);

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
            const currentIndex = inputOrder.indexOf(e.target.name);
            if (currentIndex !== -1 && currentIndex < inputOrder.length - 1) {
                const nextFieldName = inputOrder[currentIndex + 1];
                refs[nextFieldName].current?.focus();
            } else if (currentIndex === inputOrder.length - 1) {
                // Focus first type of access in grid when done with header
                setFocusedCell([0, 'create']);
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (viewOnly) {
                closeModal_sec && closeModal_sec();
            } else {
                setSubmitConfirm('Quit');
            }
        }
    };

    const handleCellChange = (rowIndex, field, value) => {
        setPermissions(prev => {
            const updated = [...prev];
            // Shallow clone the row object to prevent in-place mutation of sharing objects
            updated[rowIndex] = { ...updated[rowIndex], [field]: value };
            return updated;
        });
    };

    const handleCellKeyDown = (e, rowIndex, field) => {
        const colIndex = permissionCols.indexOf(field);
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (rowIndex > 0) {
                setFocusedCell([rowIndex - 1, field]);
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (rowIndex < permissions.length - 1) {
                setFocusedCell([rowIndex + 1, field]);
            }
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            if (colIndex > 0) {
                setFocusedCell([rowIndex, permissionCols[colIndex - 1]]);
            }
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            if (colIndex < permissionCols.length - 1) {
                setFocusedCell([rowIndex, permissionCols[colIndex + 1]]);
            }
        } else if (e.key === 'Tab' || e.key === 'Enter') {
            e.preventDefault();
            if (colIndex < permissionCols.length - 1) {
                setFocusedCell([rowIndex, permissionCols[colIndex + 1]]);
            } else {
                if (rowIndex < permissions.length - 1) {
                    setFocusedCell([rowIndex + 1, 'create']);
                } else {
                    // Reached the end, trigger submit prompt
                    setSubmitConfirm('Accept');
                }
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            if (viewOnly) {
                closeModal_sec && closeModal_sec();
            } else {
                setSubmitConfirm('Quit');
            }
        }
    };

    const validateForm = () => {
        if (viewOnly) return false;
        if (!formData.ledgerName) {
            toast.error("Ledger Name is required", { position: toast.POSITION.TOP_CENTER });
            refs.ledgerName.current?.focus();
            return false;
        }
        if (!formData.username.trim()) {
            toast.error("Username is required", { position: toast.POSITION.TOP_CENTER });
            refs.username.current?.focus();
            return false;
        }
        if (!editData && !formData.password) {
            toast.error("Password is required", { position: toast.POSITION.TOP_CENTER });
            refs.password.current?.focus();
            return false;
        }
        if (formData.password !== formData.confirmPassword) {
            toast.error("Passwords do not match", { position: toast.POSITION.TOP_CENTER });
            refs.confirmPassword.current?.focus();
            return false;
        }
        if (!formData.designation) {
            toast.error("Designation is required", { position: toast.POSITION.TOP_CENTER });
            refs.designation.current?.focus();
            return false;
        }
        return true;
    };

    const prepareSubmitData = () => {
        const companyId = userData?.company_id || localStorage.getItem("company_id");
        const selectedLedger = ledgers.find(l => String(l.id) === String(formData.ledgerName));
        const submitData = {
            company_id: companyId,
            ledger_id: formData.ledgerName,
            ledger_name: selectedLedger ? selectedLedger.ledger_name : '',
            username: formData.username,
            email: formData.email,
            designation: formData.designation,
            user_status: formData.userStatus,
            allowed_back_dated: formData.allowedBackDated,
            cut_off_date: formData.cutOffDate
        };

        submitData.permissions = permissions;

        if (formData.password) {
            submitData.password = formData.password;
        }
        if (editData && editData.id) {
            submitData.id = editData.id;
        }
        return prepareFormData(submitData);
    };

    const handleSuccess = (response) => {
        if (onSuccess) {
            const selectedLedger = ledgers.find(l => String(l.id) === String(formData.ledgerName));
            onSuccess({
                id: response?.data?.id || editData?.id,
                name: selectedLedger ? selectedLedger.ledger_name : (response?.data?.name || ''),
                account_no: selectedLedger ? selectedLedger.id : (response?.data?.account_no || formData.ledgerName),
                username: response?.data?.username || formData.username,
                designation: response?.data?.designation || formData.designation,
                email: response?.data?.email || formData.email,
                status: response?.data?.status || formData.userStatus
            });
        }
        closeModal_sec && closeModal_sec();
    };


    const { handleSubmit, loading } = useFormHandler({
        validateForm,
        prepareFormData: prepareSubmitData,
        submitForm: (data) => dispatch(editData ? companyUserUpdate(data) : companyUserCreate(data)),
        isAlter: false,
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => handleSubmit(new Event('submit')),
            },
        ],
        resetForm: () => {
            setFormData({
                ledgerName: ledgers[0]?.id || '',
                username: '',
                password: '',
                confirmPassword: '',
                email: ledgers[0]?.email || '',
                designation: 'Owner',
                userStatus: 'Active',
                allowedBackDated: 'Yes',
                cutOffDate: '23-Dec-2025 (Tuesday)',
            });
        },
        first_ref: refs.ledgerName,
        closeModal: closeModal_sec,
        onSuccess: handleSuccess,
        setSubmitConfirm,
        submitConfirm,
        customFocusReset: handleFocusReset
    });

    // Dropdown choices
    const designations = ['Owner', 'Manager', 'Accountant', 'Data Entry'];
    const statuses = ['Active', 'Inactive'];
    const yesNoOptions = ['Yes', 'No'];
    console.log(editData);
    return (
        <Form
            handleSubmit={handleSubmit}
            handleKeyDown={handleFormKeyDown}
            submitConfirm={submitConfirm}
            handleFocusReset={handleFocusReset}
            title={viewOnly ? 'User View' : editData ? 'User Alteration' : 'User Creation'}
            loading={loading}
            col='col-12'
            Footer={MasterCreationFooter}
            closeModal_sec={closeModal_sec}
            isView={viewOnly}
            isAlter={!!editData && !viewOnly}
        >
            <div className="container-fluid p-2" style={{ background: '#f8f9fa', fontSize: '12px', display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
                {/* Header Information Section */}
                <div className="row g-2 mb-3 bg-white p-3 border rounded shadow-sm">
                    {/* Left Column of Header */}
                    <div className="col-md-6 border-end pe-3">
                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Ledger Name (Ac No.)</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <select
                                    className="form-select form-select-sm fw-bold border-secondary"
                                    name="ledgerName"
                                    value={formData.ledgerName}
                                    onChange={handleChange}
                                    ref={refs.ledgerName}
                                    style={{ fontSize: '12px', background: '#eef2f7' }}
                                    disabled={viewOnly}
                                >
                                    <option value="">Select Ledger</option>
                                    {ledgers.map(l => (
                                        <option key={l.id} value={l.id}>
                                            {l.ledger_name} ({l.id})
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Username</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    ref={refs.username}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Password</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="password"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    ref={refs.password}
                                    style={{ fontSize: '12px' }}
                                    placeholder={editData ? "Leave blank to keep unchanged" : ""}
                                    disabled={viewOnly}
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Confirm Password</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="password"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    ref={refs.confirmPassword}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">E-mail</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="email"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    ref={refs.email}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right Column of Header - User Settings */}
                    <div className="col-md-6 ps-3 text-start">
                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Designation</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <select
                                    className="form-select form-select-sm fw-bold border-secondary"
                                    name="designation"
                                    value={formData.designation}
                                    onChange={handleChange}
                                    ref={refs.designation}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                >
                                    {designations.map(d => <option key={d} value={d}>{d}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className={`col-4 fw-bold text-start ${formData.userStatus === 'Inactive' ? 'text-danger' : 'text-success'}`}>User Status</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <select
                                    className={`form-select form-select-sm fw-bold ${formData.userStatus === 'Inactive' ? 'text-danger border-danger' : 'text-success border-success'}`}
                                    name="userStatus"
                                    value={formData.userStatus}
                                    onChange={handleChange}
                                    ref={refs.userStatus}
                                    style={{ fontSize: '12px', background: formData.userStatus === 'Inactive' ? '#fdf2f2' : '#eafaf1' }}
                                    disabled={viewOnly}
                                >
                                    {statuses.map(s => <option key={s} value={s}>{s}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Allowed for Back Dated Vouchers</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <select
                                    className="form-select form-select-sm fw-bold border-secondary"
                                    name="allowedBackDated"
                                    value={formData.allowedBackDated}
                                    onChange={handleChange}
                                    ref={refs.allowedBackDated}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                >
                                    {yesNoOptions.map(y => <option key={y} value={y}>{y}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col-4 fw-bold text-start">Cut-Off Date for Back Dated Vouchers</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="cutOffDate"
                                    value={formData.cutOffDate}
                                    onChange={handleChange}
                                    ref={refs.cutOffDate}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Permissions Grid Section */}
                <div className="bg-white mb-2" style={{ overflowY: 'auto', flex: 1, border: '1px solid #cccccc' }}>
                    <table className="table table-bordered table-sm m-0 user-permission-table" style={{ fontSize: '11px' }}>
                        <thead className="table-secondary fw-bold" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <tr>
                                <th rowSpan="2" style={{ width: '25%' }} className="text-start ps-3 align-middle">Facilities / Features Name</th>
                                <th rowSpan="2" style={{ width: '20%' }} className="text-start align-middle">Facilities / Features Type</th>
                                <th colSpan="8" className="text-center py-1">Permissions</th>
                            </tr>
                            <tr>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Create</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Alter</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>View</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Delete</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Print</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Export</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Email</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>WhatsApp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {permissions.map((item, idx) => {
                                // Group divider rendering
                                const showCategoryHeader = idx === 0 || permissions[idx - 1].category !== item.category;

                                return (
                                    <React.Fragment key={item.id}>
                                        {showCategoryHeader && (
                                            <tr className="table-light">
                                                <td colSpan="10" className="text-start fw-bold ps-2 py-1 text-secondary" style={{ background: '#f0f0f0', fontSize: '11px', letterSpacing: '0.5px' }}>
                                                    {item.category}
                                                </td>
                                            </tr>
                                        )}
                                        <tr className="align-middle">
                                            <td className="text-start ps-3 fw-bold text-dark">{item.name}</td>
                                            <td className="text-start text-muted">{item.type}</td>
                                            {permissionCols.map(col => {
                                                const isFocused = focusedCell[0] === idx && focusedCell[1] === col;
                                                return (
                                                    <td
                                                        key={col}
                                                        className="text-center p-0"
                                                        style={{
                                                            background: isFocused ? '#eef2f7' : 'transparent',
                                                            outline: isFocused ? '1px dashed #0d6efd' : 'none',
                                                            outlineOffset: '-1px'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={!!item[col]}
                                                            data-row={idx}
                                                            data-col={col}
                                                            onChange={(e) => handleCellChange(idx, col, e.target.checked)}
                                                            onKeyDown={(e) => handleCellKeyDown(e, idx, col)}
                                                            onFocus={() => setFocusedCell([idx, col])}
                                                            style={{ cursor: 'pointer', margin: '4px 0' }}
                                                            disabled={viewOnly}
                                                        />
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </Form>
    );
}

export default React.memo(UserAndPasswordCreate);
